import { isMobile } from "./isMobile";

/*
 * Fixed position header
 * ----------------------------------------------- */
jQuery(window).on("load scroll", function () {
  if (isMobile()) {
    return false;
  }

  var $jsHeader = $(".js-header");

  $jsHeader.each(function () {
    var scroll = $(window).scrollTop();

    if (scroll > 500) {
      $jsHeader.addClass("is-scrolled");
    } else {
      $jsHeader.removeClass("is-scrolled");
    }
  });
});

/*
 * collapse navbar in mobile when click link
 * ----------------------------------------------- */
$(".navbar-simple .navbar-nav li a").on("click", function () {
  if (isMobile()) {
    $(".navbar-toggle").click();
  }
});
